import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { useEffect } from 'react';
import AuthService from '../auth/AuthService';

const Auth = new AuthService();

const BreakAlertModal = ({
    open,
    onAcknowledge,
    formattedTime,
    selectedRouteData
}) => {

    useEffect(() => {
        if (open) {
            logBreakAlert();
        }
    }, [open]);

    const logBreakAlert = async () => {
        try {
            const body = {
                route_status_id: selectedRouteData?.id,
                route_id: selectedRouteData?.route_id,
                vehicle_id: selectedRouteData?.vehicle_id,
                driver_id: selectedRouteData?.driver_id,
            };

            await Auth.fetch('/driverapp/manual-tacho-reminder', {
                method: 'POST',
                body: JSON.stringify(body),
            });
        } catch (error) {
            console.error('Failed to log break alert:', error);
        }
    };

    return (
        <Modal
            open={open}
            centered
            closable={false}
            footer={null}
            width={420}
            className="tacho-alert-modal"
            styles={{ body: { padding: '30px 24px' } }}
        >
            <div className="tacho-alert-header"></div>

            <div className="tacho-alert-icon-container">
                <ExclamationCircleOutlined style={{ fontSize: 56, color: '#ff4d4f' }} />
            </div>

            <div className="tacho-alert-title">Mandatory Break Required</div>
            <div className="tacho-alert-subtitle">Safety Regulation Notice</div>

            <div className="tacho-timer-display">
                <div className="tacho-timer-label">Continuous Driving Time</div>
                <div className="tacho-timer-value">{formattedTime}</div>
            </div>

            <p className="tacho-alert-message">
                You have reached the maximum continuous driving limit.
                Please initiate a <strong>45-minute break</strong> immediately to comply with safety regulations.
            </p>

            <Button
                type="primary"
                danger
                size="large"
                className="premium-stop-button"
                style={{ width: '100%' }}
                onClick={onAcknowledge}
            >
                Acknowledge & Take Break
            </Button>
        </Modal>
    );
};

export default BreakAlertModal;
